export default __webpack_public_path__ + "e88f6ab69e9fa63b667dab3889f38e99.png";